import { DialogsModule } from "@/utils/dialogs-module";
import "Dialogs/poll-folder/select-poll-folder-dialog";
import { Translator } from "@/utils/translate";

const pollsTranslator = Translator("polls");

const CREATE_POLL_LINK = "/foquz/lk/new-poll";

const getCreatePollLink = (baseLink, params = {}) => {
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value == null || value === "") return;
    searchParams.set(key, value);
  });

  const search = searchParams.toString();

  return search ? `${baseLink}?${search}` : baseLink;
};

const handlePollCreate = (params) => {
  location.href = getCreatePollLink(CREATE_POLL_LINK, params);
};

/**
 * Создает новый опрос с учетом прав пользователя
 * @param {boolean} isEditor - является ли пользователь редактором
 * @param {Object} urlParams - дополнительные параметры URL
 * @param {Event} event - событие клика
 */
export const createPoll = (isEditor, urlParams = {}, event) => {
  event?.preventDefault?.();
  event?.stopPropagation?.();

  const pollCreateElement =
    event?.target?.closest?.("[data-poll-create]") ||
    event?.currentTarget?.closest?.("[data-poll-create]") ||
    event?.currentTarget ||
    null;
  const folder = pollCreateElement?.getAttribute?.("data-folder");
  const params = {
    ...urlParams,
  };

  if (folder && !params.folder_id) {
    params.folder_id = folder;
  }

  if (isEditor) {
    const dialogs = DialogsModule();
    dialogs.openDialog({
      name: "select-poll-folder-dialog",
      params: {
        title: pollsTranslator.t("Выберите папку для создания опроса"),
        confirm: pollsTranslator.t("Создать опрос"),
        mode: "success",
        current: params.folder_id || "0",
        // Редактор не может создавать опросы на "Главной странице" (#6535, п.11).
        // В расширенном режиме остаются доступными гостевые папки и их поддеревья.
        disabled: ["0"],
        activateGuestFolders: true,
        onSelect: (folderId) => {
          return new Promise((resolve) => {
            handlePollCreate({
              ...params,
              folder_id: folderId,
            });
            resolve();
          });
        },
      },
    });
  } else {
    handlePollCreate(params);
  }
};
